export default {"src":"/_next/static/media/arrow-right.912f28cd.svg","height":12,"width":6,"blurWidth":0,"blurHeight":0};